import HeartDoodle from '@monofront/design-system/visuals/Illustrations/HeartDoodle';
import SpacerDoodle from '@monofront/design-system/visuals/Illustrations/SpacerDoodle';
import { EStickerVariants } from '@monofront/design-system/visuals/Backgrounds/StickerBackground';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { formatPrismicData } from '@monofront/business/utils';
import { useMediaQuery } from '@monofront/business/hooks';
import Bubble from '@components/Bubble';
import { ISingleBubbleContent, SingleBubbleProps } from './types';

const SingleBubble = ({
  prismicContent,
}: {
  prismicContent: SingleBubbleProps;
}) => {
  const content: ISingleBubbleContent = formatPrismicData(prismicContent);
  const isMobile = useMediaQuery(800);

  return (
    <section className="tw-flex tw-items-center tw-justify-center tw-gap-6">
      {!isMobile && content.primary.image?.url && (
        <ResponsiveImage
          src={content.primary.image.url}
          width={content.primary.image.dimensions?.width}
          height={content.primary.image.dimensions?.height}
          layout="fixed"
          alt={content.primary.image?.alt || ''}
        />
      )}
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-5">
        {content.primary?.title && (
          <div className="[&>*]:tw-font-title [&>*]:tw-text-3xl [&>*]:tw-font-bold">
            <RichText render={content.primary.title} />
          </div>
        )}
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1 md:tw-gap-7">
          <SpacerDoodle
            width={isMobile ? 32 : 64}
            height={isMobile ? 32 : 64}
          />
          <Bubble
            title={<RichText render={content?.primary.mainText} />}
            text={<RichText render={content?.primary.subText} />}
            variant={EStickerVariants.B}
            width={isMobile ? 247 : 300}
            height={isMobile ? 195 : 236}
            backgroundColor="#FF573E"
            fontColor="#FFF"
          />
          <HeartDoodle width={isMobile ? 32 : 64} height={isMobile ? 32 : 64} />
        </div>
      </div>
    </section>
  );
};

export default SingleBubble;
